export enum CTA_TYPE {
  BUTTON = "Button",
  HYPER_LINK = "Hyperlink",
  RADIO_BUTTON = "Radio Button",
  IMAGES = "Images"
}

export function pushOmniEvents(data: { eventName: string, details: any }) {
  try {
    window.adobeDataLayer = window.adobeDataLayer || []
    window.adobeDataLayer.push({
      event: data.eventName,
      ...data.details
    })
  } catch (err) {
    console.log(err)
  }
}